import React, { memo } from "react";
import { array, object, string, func } from "prop-types";
import { FormControl, Select, MenuItem } from "@material-ui/core";

import parentStyle from "../../style.module.scss";
import style from "./style.module.scss";
import ItemGroup from "components/ShapeList/ItemGroup";

const GRID_BODY = "minmax(90px, 1fr) minmax(80px, 0.5fr)  40px ";

export default memo(HistoryShapeList);

HistoryShapeList.propTypes = {
  labelTypes: array,
  shapesByLabel: object,
  selectedLabelId: string,
  onSelectLabel: func,
};

function HistoryShapeList({
  labelTypes,
  shapesByLabel,
  selectedLabelId,
  onSelectLabel,
}) {
  const labelIds = Object.keys(shapesByLabel);
  const totalShapes = labelIds.reduce(
    (sum, labelId) => sum + shapesByLabel[labelId].length,
    0
  );

  return (
    <>
      <div className={parentStyle.labelTypeRow}>
        <span className={parentStyle.labelTypeLabel}>Label Type:</span>
        <FormControl
          variant="outlined"
          className={parentStyle.labelTypeSelect}
          size="small"
        >
          <Select
            value={selectedLabelId}
            onChange={(e) => onSelectLabel(e.target.value)}
            displayEmpty
          >
            <MenuItem value={""}>All</MenuItem>
            {labelTypes.map((type) => (
              <MenuItem key={type.labelId} value={type.labelId}>
                {type.labelTypeName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <span className={style.shapeCount}>{totalShapes} shapes</span>
      </div>

      <div className={parentStyle.itemContainer}>
        {totalShapes === 0 ? (
          <div className={parentStyle.emptyState}>
            Không có nhãn nào trong lượt này
          </div>
        ) : (
          labelIds.map((labelId) => (
            <ItemGroup
              key={labelId}
              labelId={labelId}
              shapes={shapesByLabel[labelId]}
              gridBody={GRID_BODY}
              hideCheckbox
            />
          ))
        )}
      </div>
    </>
  );
}
